<template>
  <div class="text-xs-center">
    <v-btn
      :disabled="dialog"
      :loading="dialog"
      class="white--text"
      color="purple darken-2"
      @click="dialog = true"
    >
      Start loading
    </v-btn>
    <v-dialog
      style="z-index:10000!important"
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="pt-2">
          {{$store.getters.loaderMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isLoading: true,
      isFullPage: true,
      dialog: true
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.v-overlay {
    z-index: 10000!important;
}
/* .v-dialog__content {
    z-index: 10002!important;
} */
</style>



// WEBPACK FOOTER //
// src/View/components/Loader.vue